import React from 'react'

export default function Sucursal() {
  return (
    <div>Perfil de la sucursal</div>
  )
}
